<template>
  <div class="list">
    <div class="title">
      会话
      <span v-if="c2cConversationList.length > 0"
        >({{ c2cConversationList.length }})</span
      >
    </div>
    <div class="scroll-container" v-if="c2cConversationList.length > 0">
      <conversation-list-item
        v-for="item in c2cConversationList"
        :conversation="item"
        :key="item.conversationID"
      />
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const { mapState } = createNamespacedHelpers("im");
import ConversationListItem from "./conversation-list-item";
export default {
  name: "conversationList",
  data() {
    return {};
  },
  components: { ConversationListItem },
  computed: {
    ...mapState(["c2cConversationList"]),
  },
  created() {},
  methods: {},
};
</script>

<style scoped lang="scss">
.list {
  border-right: 1px solid #e7e7e7;
  height: 100%;
  .title {
    line-height: 48px;
    padding-left: 20px;
    font-size: 16px;
    border-bottom: 1px solid #e7e7e7;
  }
  .scroll-container {
    // padding: 8px 12px;
    // overflow: hidden;
    height: 100%;
    overflow-x: hidden;
    overflow-y: auto;
  }
}
</style>
